import React, {Component} from "react";
import {connect} from "react-redux";
import "./Home.css";
import {Button, Col, Container, Form, Row} from "react-bootstrap";
import DashboardService from "../services/DashboardService";
import UserDataTable from "../components/UserDataTable";
import RebootAlertModal from "../components/RebootAlertModal";
import UnpairAlertModal from "../components/UnpairAlertModal";
import DeviceConfigModal from "../components/DeviceConfigModal";
import PirCaptureAlertModal from "../components/PirCaptureAlertModal";
import _ from 'lodash';
import Helper from "../utils/Helper";

const strings = require('../resources/strings.json');

class Dashboard extends Component {
    state = {
        data: [],
        userInfo: "",
        requestMail: "",
        show: false,
        rebootDeviceShow: false,
	    deviceConfigShow: false,
        pirCaptureShow: false,
        restartMacId:"",
        pirDebugMacId:"",
        premises: [],
        selectedPremise: {},
        isValidated: false,
        selectedPremiseId: 0,
        selectedPremiseName: "",
        devices: {},
        configMacId: "", 
        configdeviceName: "", 
        configdeviceAreaName: "",
        configtimestamp: 0,
        unpairDeviceId : 0,
        unpairDeviceShow : false,
    };

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleFetchClick = this.handleFetchClick.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handlePirCaptureShow = this.handlePirCaptureShow.bind(this);
        this.handlePirCaptureClose = this.handlePirCaptureClose.bind(this);
        this.onSelectPremise = this.onSelectPremise.bind(this);
        this.handleRefreshClick = this.handleRefreshClick.bind(this);
        this.handleDetails = this.handleDetails.bind(this);
        this.validateInput = this.validateInput.bind(this);
    }

    handleClose() {
        this.setState({show: false ,rebootDeviceShow: false, deviceConfigShow: false, unpairDeviceShow : false});
    }

    handleShow(row) {
        this.setState({show: true, selectedDevice: row});
    }

    handlePirCaptureClose() {
        this.setState({show: false , pirCaptureShow: false});
    }

    handlePirCaptureShow(row) {
        this.setState({show: true, selectedDevice: row});
    }

    handleChange = function (event) {
        this.setState({
            userInfo: event.target.value   
        });
    };
  

    handleFetchClick = async event => {
        this.state.userInfo= this.state.userInfo.trim();
        if (!this.validateInput()) {
            alert(strings.enterValidEmailMac)
            return;
        }

        this.setState({requestMail: "", selectedPremise: {}, selectedPremiseName: ""});
        try {
            //call this method to clear premises-reducer
            await DashboardService.clearUserData();
            const userEmail = await DashboardService.getPremise(this.state.userInfo);
            this.setState({
                requestMail: userEmail
            })
        } catch (e) {
            alert(this.getErrorMessage(e));
        }
    };

    getErrorMessage(e) {
        if (e.response && e.response.data.error) {
            return e.response.data.message;
        } else if(e instanceof Error){  
            return(e.message);
        } else {
            return "There was an error fetching account information for this email or device."
        }
    }

    handleRefreshClick = async event => {
        if (!this.state.requestMail || this.state.requestMail === "") {
            return;
        }
        
        this.setState({requestMail: this.state.requestMail});
        try {
            await DashboardService.getPremise(this.state.requestMail);
        } catch (e) {
            alert(this.getErrorMessage(e));
        }
    };

    validateInput = () => {
        return (
            this.state.userInfo && 
            this.state.userInfo != "" &&
            (Helper.validateEmail(this.state.userInfo) ||
            Helper.validateMac(this.state.userInfo))
        )
    }

    handleDetails(){
        this.setState({deviceConfigShow: true});
    }

    onSelectPremise = function (event) {
        this.setState({selectedPremiseId : event.target.value}, () => {
            this.updatedRowData();
        })
    };

    updatedRowData(){
        for (let i = 0; i < this.props.premise.length; i++) {
            if (this.props.premise[i].id == this.state.selectedPremiseId) {
                let selectedPremise = _.cloneDeep(this.props.premise[i]);
                let areas = selectedPremise.areas;
                let data = [];
                let devices = {};
                this.setState({ devices: {} });
                for (let i = 0; i < areas.length; i++) {
                    data.push({ areaName: areas[i].name });
                    for (let j = 0; j < areas[i].devices.length; j++) {
                        let device = areas[i].devices[j];
                        let deviceRow = {};
                        deviceRow.id = device.id;
                        deviceRow.mac = device.mac;
                        deviceRow.deviceName = device.name;
                        deviceRow.deviceAreaName = areas[i].name;
                        deviceRow.status = device.status;
                        deviceRow.parent = areas[i].id;
                        deviceRow.type = device.type;
                        deviceRow.subType = device.subType;
                        devices[device.id] = {};
                        devices[device.id].mac = device.mac;
                        devices[device.id].type = device.type;

                        //NOTE :  Device details paramater needed for any use-case to be parsed from rawShadow of the device and not from individiual params.
                        if (device.state.rawShadow) {
                            //Common parameter for all shadow structures
                            deviceRow.rawShadow = device.state.rawShadow;
                            deviceRow.connected = device.state.rawShadow.connected === "true" ? "Connected" : "Disconnected";
                            deviceRow.loadLevel = device.state.rawShadow.LoadLevel;
                            deviceRow.mode = device.state.rawShadow.Mode;

                            if (device.state.rawShadow.info && device.state.rawShadow.info.ShadowVersion !== undefined && device.state.rawShadow.info.ShadowVersion.Mj === 2 && device.state.rawShadow.sensor !== undefined) {
                                // If shadow version is 2.0.0 and above and sensor object is present inside shadow Read Lux and Occupancy from Sensor.
                                deviceRow.occupancy = device.state.rawShadow.sensor.Occupancy ? "true" : "false";
                                deviceRow.lux = device.state.rawShadow.sensor.Lux;
                                deviceRow.cpuVersion = this.getVersionStringForKey(device.state.rawShadow.info.SwVersionMcpu);
                                deviceRow.stmVersion = this.getVersionStringForKey(device.state.rawShadow.info.SwVersionCop);
                                deviceRow.wifiVersion = this.getVersionStringForKey(device.state.rawShadow.info.SwVersionWifi);

                            }
                            // If Shadow structure is flat.
                            else {
                                deviceRow.occupancy = device.state.rawShadow.Occupancy ? "true" : "false";
                                deviceRow.lux = device.state.rawShadow.Lux;
                                deviceRow.cpuVersion = device.state.rawShadow.SwVersionMcpu;
                                deviceRow.stmVersion = device.state.rawShadow.SwVersionCop;
                                deviceRow.wifiVersion = device.state.rawShadow.SwVersionWifi;
                            }
                        }
                        data.push(deviceRow);
                    }
                }
                selectedPremise.areas = data;
		        this.setState({
                    selectedPremise: selectedPremise, 
                    devices: devices,
                    selectedPremiseName : selectedPremise.name
                });
            }
        }
    }

    createSelectItems() {
        let items = [];
        let builds = this.state.builds;
        if (builds) {
            for (let i = 0; i < builds.length; i++) {
                items.push(<option key={builds[i].id} value={builds[i].id}>{builds[i].version}</option>)
            }
            this.setState({buildOptions: items})
        }
    }
    
    componentDidUpdate(prevProps) {
        if (this.props !== prevProps && this.props.premise) {
            this.updatedRowData();
        }
    }

     /**
     * In the structured shadow Major. Minor and revision version are displayed as key value pair.
     * To display this information on UI components we need to
     * @param versionDict
     * @returns {string}
     */
      getVersionStringForKey(versionDict) {
        if(versionDict === undefined || versionDict === null)
        {   
            return('')
        }
        let versionString = "-";
        let keyArray = Object.keys(versionDict);
        for (const key of keyArray) {
            versionString = versionString + "." + versionDict[key]
        }
        const finalVersionString = versionString.substring(2);
        return finalVersionString;
    }

    
    restartSwitch()
    {
        this.handleClose();
        DashboardService.restartDevice(this.state.restartMacId);    
    }

    unpairSwitch()
    {
        this.handleClose();
        DashboardService.unpairDevice(this.state.unpairDeviceId);    
    }

    getPirData()
    {
        this.handlePirCaptureClose()
        DashboardService.getPirDataForDevice(this.state.pirDebugMacId);    
    }  

    render() {
        return (
            <Container>
                <Row style={{marginTop: 40}}>
                    <Form>
                        <Form.Group controlId="exampleForm.ControlInput1">
                            <Col sm={4}>
                                <Form.Control required type="text" placeholder="name@example.com or 12 character MAC"
                                              onChange={this.handleChange}/>
                            </Col>
                            <Col sm={2}>
                                <Button variant="primary" onClick={this.handleFetchClick}
                                        style={{marginRight: 16}}>Fetch</Button>

                            </Col>
                            <Col sm={4}>
                        <select className="form-control" value={this.state.value}
                                onChange={this.onSelectPremise}>
                            <option>Select Premise</option>
                            {
                                this.props.premise ? (
                                    this.props.premise.map((e, key) => {
                                        if(e.id == this.state.selectedPremiseId){
                                            return <option selected key={key} value={e.id}>{e.name}</option>;
                                        }
                                        return <option key={key} value={e.id}>{e.name}</option>;
                                    })
                                ): null
                            }
                        </select>
                    </Col>
                        </Form.Group>
                    </Form>
                </Row>
                <hr/>
                <Row>
                    <Col sm={3}>
                    User : <span id="request_mail_id">{this.state.requestMail}</span>
                    </Col>
                    <Col sm={3}>
                    Premise : <span id="selected_premise_val">{this.state.selectedPremiseName}</span>
                    </Col>
                    <Col sm={2}>
                        <Button variant="primary"  onClick={this.handleRefreshClick}>Refresh</Button>
                    </Col>
                </Row>
                <Row style={{marginTop: 16}}>
                    <Col sm={12}>
                        {
                            this.state.selectedPremise.areas ?
                                <UserDataTable
                                    onClick={(event, row) => {
                                        this.handleShow(row);
                                    }}
                                    onRebootClicked = {(macId)=>{
                                        this.setState({rebootDeviceShow: true, restartMacId: macId})
                                    }}
                                    onUnpairClicked = {(deviceId)=>{
                                        this.setState({unpairDeviceShow: true, unpairDeviceId: deviceId})
                                    }}
                                    onGetPirDataClicked = {(macId)=>{
                                        this.setState({pirCaptureShow: true, pirDebugMacId: macId})
                                    }}
				                    onConfigClicked = {(macId, deviceName, deviceAreaName, deviceConfigShow)=>{
                                        if(deviceConfigShow === false){
                                            alert('This feature is not available with this device.');
                                        }else{
                                            this.setState({deviceConfigShow: true, configtimestamp: new Date().getTime(), configMacId: macId, configdeviceName: deviceName, configdeviceAreaName: deviceAreaName});    
                                        }    
                                    }} 
                                    devices={this.state.devices}
				                    user={this.state.requestMail}
                                    selectedPremise={this.state.selectedPremise}
                                /> : null
                        }
                    </Col>
                </Row>
                <RebootAlertModal
                    show ={this.state.rebootDeviceShow}
                    onCloseClicked={() => this.handleClose()}
                    onRestartSwitch={()=> this.restartSwitch()}
                />
                <UnpairAlertModal
                    show ={this.state.unpairDeviceShow}
                    onCloseClicked={() => this.handleClose()}
                    onUnpairSwitch={()=> this.unpairSwitch()}
                />
                <PirCaptureAlertModal
                    show ={this.state.pirCaptureShow}
                    onCloseClicked={() => this.handlePirCaptureClose()}
                    onContinueClicked={()=> this.getPirData()}
                />
		        <DeviceConfigModal
                    deviceConfigShow ={this.state.deviceConfigShow}
                    configtimestamp={this.state.configtimestamp}
                    configUserId={this.state.requestMail}
                    configPremiseName={this.state.selectedPremiseName}
                    configMacId={this.state.configMacId}
                    configdeviceName={this.state.configdeviceName}
                    configdevicAreaName={this.state.configdeviceAreaName}
                    onCloseClicked={() => this.handleClose()}
                    premises={this.state.selectedPremise}
                />
            </Container>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        premise: state.userInfoReducer.premiseData
    };
};

const R_Dashboard = connect(mapStateToProps)(Dashboard);
export default R_Dashboard;
